import {
  Controller
} from "stimulus";
import {
  get
} from "@rails/request.js";

export default class extends Controller {
  getTurboStream(event) {
    event.preventDefault()
    get(event.currentTarget.href, {
      contentType: "text/vnd.turbo-stream.html",
      responseKind: "turbo-stream"
    })
  }
}
